import { InMemoryCache } from "@apollo/client";

import { possibleTypes } from "@shared/data/client";
import { connectionAppendPagination } from "@shared/data/client/connectionAppendPagination";

interface Params {
  ssr: boolean;
}

const getCache = ({ ssr }: Params) => {
  const cache = new InMemoryCache({
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          open: {
            merge: true,
          },
        },
      },
      Viewer: {
        // This means the singleton Viewer's identity does not depend on any of its
        // fields (except for __typename), making the ID effectively constant.
        keyFields: [],
        fields: {
          products: connectionAppendPagination(["filters"]),
          productSearch: connectionAppendPagination([
            "query",
            "brandIds",
            "categoryIds",
            "tags",
            "childTags",
            "inStockOnly",
          ]),
          productSearchV2: connectionAppendPagination([
            "query",
            "brandIds",
            "supplementTypeIds",
            "categoryIds",
            "ingredients",
            "allergenIds",
            "thirdPartyCertificationIds",
            "dosageFormatIds",
            "inStockOnly",
            "sort",
            "filters",
            "onlyIngredient",
            "onlyWholesaleHistory",
          ]),
          typeaheadSearch: connectionAppendPagination(["filters", "sort", "query"]),
          supplementTypes: connectionAppendPagination(),
          brands: connectionAppendPagination(["filters"]),
        },
      },
      Open: {
        keyFields: [],
        fields: {
          products: connectionAppendPagination(["filters"]),
          productSearchV2: connectionAppendPagination([
            "query",
            "brandIds",
            "supplementTypeIds",
            "categoryIds",
            "ingredients",
            "allergenIds",
            "thirdPartyCertificationIds",
            "dosageFormatIds",
            "inStockOnly",
            "sort",
            "filters",
            "onlyIngredient",
            "onlyWholesaleHistory",
            "includeWholesale",
            "campaignIds",
            "childTags",
            "tags",
          ]),
          typeaheadSearch: connectionAppendPagination(["filters", "sort", "query"]),
          ingredients: connectionAppendPagination(["filters, sort"]),
          brands: connectionAppendPagination(["filters"]),
        },
      },
    },
  });

  if (ssr) return cache;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  return cache.restore(window.__APOLLO_STATE__);
};

export { getCache };
